import React from "react";
import { useNavigate } from "react-router-dom";
import { SidebarItems, FontWeightEnum } from "../../types/AppTypes";
import { useDimensions } from "../../hooks/useDimensions.hook";
import { StyledSidebarItemsCreator } from "./SidebarItemsCreator.styled";
import { BodyTyp } from "../Typography/Typography";
import { useEditing } from "../../providers/editing.provider";
import { Tooltip, TooltipVariantEnum } from "../core/Tooltip/Tooltip";
import { TooltipPositionEnum } from "../core/Tooltip/Tooltip.style";

type SidebarItemsCreatorProps = {
  items: SidebarItems[];
  showSidebar: boolean;
  closeSidebar: () => void;
};

export const SidebarItemsCreator = ({
  items,
  showSidebar,
  closeSidebar,
}: SidebarItemsCreatorProps) => {
  const navigate = useNavigate();
  const { confirmLeave, edit } = useEditing();

  const pageActive = window.location.hash
    .replace("#", "")
    .split("?")[0]
    .split("/")[1];
  const { isMobile } = useDimensions();

  const handleSwitchSidebarItem = (item: SidebarItems) => {
    const isNavigationRequired = typeof item.link === "string";

    const navigateOrCall = () => {
      if (isNavigationRequired) {
        navigate(item.link as string);
      } else {
        (item.link as () => void)();
      }
      if (isMobile) closeSidebar();
    };

    if (edit && confirmLeave) {
      confirmLeave(navigateOrCall);
    } else {
      navigateOrCall();
    }
  };

  return (
    <StyledSidebarItemsCreator $showSidebar={showSidebar}>
      <>
        {items.map((item, idx) => {
          return (
            <React.Fragment key={`${idx}${item.label}`}>
              <Tooltip
                message={item.label}
                variant={TooltipVariantEnum.DARK}
                hide={showSidebar}
                position={TooltipPositionEnum.RIGHT}
                autoWidth
              >
                <div
                  className={`item-sidebar ${
                    typeof item.link === "string" &&
                    item.link.split("/")[1] === pageActive &&
                    "active"
                  }`}
                  onClick={() => handleSwitchSidebarItem(item)}
                >
                  {item.icon}
                  {showSidebar && (
                    <BodyTyp variant="1" fontWeight={FontWeightEnum.MEDIUM}>
                      {item.label}
                    </BodyTyp>
                  )}
                </div>
              </Tooltip>
            </React.Fragment>
          );
        })}
      </>
    </StyledSidebarItemsCreator>
  );
};
